import React, { Component } from 'react';
import { ToolbarButton } from '../buttons/toolbar-button.js';
import styles from './toolbar.less.js';

class ToolbarRow extends Component {
    render() {
        const { row, tooltipPlacement } = this.props;
        return (React.createElement("div", { className: styles.row }, row.map(button => React.createElement(ToolbarButton, Object.assign({ key: button.name, placement: tooltipPlacement }, button)))));
    }
}

export { ToolbarRow };
//# sourceMappingURL=toolbar-row.js.map
